import { render, staticRenderFns } from "./TinplateBadge.vue?vue&type=template&id=08bf866d&scoped=true&"
import script from "./TinplateBadge.vue?vue&type=script&lang=js&"
export * from "./TinplateBadge.vue?vue&type=script&lang=js&"
import style0 from "./TinplateBadge.vue?vue&type=style&index=0&id=08bf866d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf866d",
  null
  
)

component.options.__file = "TinplateBadge.vue"
export default component.exports